jQuery(document).ready(function($) {

    $( ".bloc_paraphotos" ).each(function( index ) {

        var cibleParaPhoto = $(this).find(".visuel")

        var parent = $(this).find(".chiffres")
        var cibleChiffre = parent.find(".chiffre")

        gsap.from( cibleParaPhoto , {
            scale: 2.6,
            scrollTrigger: {
                trigger: cibleParaPhoto,
                start: 'top 100%',
                end: 'top 0%',
                scrub: 1,
                markers: false
            }
        })



        gsap.from( cibleChiffre, {
            opacity : 0,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 50%",
                scrub: 1,
            }

        })

    })

});